/**
 * Edit-session panel for sessions.
 */
import { FC } from 'react';
import { InformationMeetingForm } from './session-form-builder/InformationMeetingForm';
import { TutoringSessionForm } from './session-form-builder/TutoringSessionForm';
import type { SessionFormKind } from '@/types/inperson/session.types';

/** Props for {@link EditSessionView}. */
interface EditSessionViewProps {
  kind?: SessionFormKind;
  sessionId: string;
  onClose: () => void;
  onSuccess?: () => void;
  className?: string;
  onRequestCreateTutor?: () => void;
}

/** Edit-session panel for sessions. */
export const EditSessionView: FC<EditSessionViewProps> = ({
  kind = 'tutoring_session',
  sessionId,
  onClose,
  onSuccess,
  className,
  onRequestCreateTutor,
}) => {
  if (kind === 'information_meeting') {
    return (
      <InformationMeetingForm
        mode="edit"
        sessionId={sessionId}
        onClose={onClose}
        onSuccess={() => onSuccess?.()}
      />
    );
  }

  return (
    <TutoringSessionForm
      mode="edit"
      sessionId={sessionId}
      onClose={onClose}
      onSuccess={onSuccess}
      className={className}
      onRequestCreateTutor={onRequestCreateTutor}
    />
  );
};
